import { ChangeDetectionStrategy, Component, computed, inject, model, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { HmiLookupService } from '../pano/pages/personel/services/hmi-lookup.service';
import { SISTEM_PARAMETRE_SETLERI } from '@service/fikoyt-ui/src/lib/parametre-setleri/sistem-parametre-setleri';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

const ONCELIK_SECENEKLERI = [
  { deger: 'Düşük', renk: '#8c8c8c' },
  { deger: 'Normal', renk: '#1890ff' },
  { deger: 'Yüksek', renk: '#fa8c16' },
  { deger: 'Acil', renk: '#ff4d4f' },
];

@Component({
  selector: 'cam-cnc-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzSelectModule, NzDatePickerModule, NzDividerModule, NzIconModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="se">
      <div class="se-baslik">
        <div class="se-baslik-ikon" style="background:linear-gradient(135deg,#4338ca,#6366f1)">⚙️</div>
        <span>CNC İşlem</span>
      </div>
      <div class="se-form">
        <div class="form-grup">
          <label>Tezgah</label>
          <div class="input-wrap">
            <nz-select [ngModel]="p()?.tezgah" (ngModelChange)="guncelle('tezgah', $event)"
              nzPlaceHolder="Tezgah seçin..." nzAllowClear nzShowSearch style="width:100%"
              (nzOnSearch)="makineAra($event)" [nzDropdownRender]="tezgahFooterTpl">
              @for (m of lookup.makineler(); track m._id) {
                <nz-option [nzValue]="m.makineAdi" [nzLabel]="m.makineAdi" nzCustomContent>
                  <div class="sel-item"><span class="sel-emoji">🏭</span>
                    <div class="sel-bilgi"><span class="sel-ad">{{ m.makineAdi }}</span>
                      @if (m.makineKodu) { <span class="sel-detay">{{ m.makineKodu }}</span> }
                    </div>
                  </div>
                </nz-option>
              }
            </nz-select>
            <ng-template #tezgahFooterTpl>
              <nz-divider style="margin:4px 0"></nz-divider>
              <div class="aku-hizli-ekle" (mousedown)="$event.preventDefault()" (click)="yeniTezgahEkle()">
                <nz-icon nzType="plus" /> Yeni Tezgah Ekle
              </div>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Operatör</label>
          <div class="input-wrap">
            <nz-select [ngModel]="p()?.operator" (ngModelChange)="guncelle('operator', $event)"
              nzPlaceHolder="Operatör seçin..." nzAllowClear nzShowSearch style="width:100%"
              (nzOnSearch)="personelAra($event)" [nzDropdownRender]="personelFooterTpl">
              @for (pr of lookup.personeller(); track pr._id) {
                <nz-option [nzValue]="pr.ad + ' ' + pr.soyad" [nzLabel]="pr.ad + ' ' + pr.soyad" nzCustomContent>
                  <div class="sel-item"><span class="sel-emoji">👤</span><span class="sel-ad">{{ pr.ad }} {{ pr.soyad }}</span></div>
                </nz-option>
              }
            </nz-select>
            <ng-template #personelFooterTpl>
              <nz-divider style="margin:4px 0"></nz-divider>
              <div class="aku-hizli-ekle" (mousedown)="$event.preventDefault()" (click)="yeniPersonelEkle()">
                <nz-icon nzType="plus" /> Yeni Personel Ekle
              </div>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Öncelik</label>
          <div class="input-wrap">
            <nz-select [ngModel]="p()?.oncelik || 'Normal'" (ngModelChange)="guncelle('oncelik', $event)"
              style="width:100%" [nzCustomTemplate]="oncelikTpl">
              @for (o of oncelikler; track o.deger) {
                <nz-option [nzValue]="o.deger" [nzLabel]="o.deger" nzCustomContent>
                  <div style="display:flex;align-items:center;gap:6px">
                    <span style="display:inline-block;width:10px;height:10px;border-radius:50%" [style.background]="o.renk"></span>
                    <span>{{ o.deger }}</span>
                  </div>
                </nz-option>
              }
            </nz-select>
            <ng-template #oncelikTpl let-s>
              <span style="display:inline-flex;align-items:center;gap:6px">
                <span style="display:inline-block;width:10px;height:10px;border-radius:50%" [style.background]="oncelikRenk(s?.nzValue)"></span>
                <span>{{ s?.nzLabel }}</span>
              </span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Hedef Bitiş Tarihi</label>
          <div class="input-wrap">
            <nz-date-picker [ngModel]="p()?.hedefTarih" (ngModelChange)="guncelle('hedefTarih', $event)"
              nzPlaceHolder="Teslim tarihi..." nzShowTime style="width:100%"></nz-date-picker>
            <div class="input-glow"></div>
          </div>
          @if (gecikmeGun() !== null) {
            <div class="stok-uyari" [class.stok-uyari--tehlike]="gecikmeGun()! <= 0" [class.stok-uyari--uyari]="gecikmeGun()! > 0 && gecikmeGun()! <= 3">
              {{ gecikmeGun()! <= 0 ? '⛔ GECİKME: ' + (-gecikmeGun()!) + ' gün geçti!' : '⏰ ' + gecikmeGun() + ' gün kaldı' }}
            </div>
          }
        </div>

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Notlar</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off"
              [ngModel]="p()?.notlar || ''" (ngModelChange)="guncelle('notlar', $event)"
              placeholder="İşlem notları..." cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4"></textarea>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrl: './cam-edit.styles.less',
})
export class CamCncEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  lookup = inject(HmiLookupService);
  private modal = inject(NzModalService);
  private vcr = inject(ViewContainerRef);

  constructor() { super(); this.lookup.makineleriYukle(); this.lookup.personelleriYukle(); }

  p = computed(() => this.parametreler()?.ek || {});
  oncelikler = ONCELIK_SECENEKLERI;
  oncelikRenk(v: string): string { return ONCELIK_SECENEKLERI.find(o => o.deger === v)?.renk || '#1890ff'; }

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) { params.ek[alan] = deger; this.parametreler.set({ ...params }); }
  }

  makineAra(terim: string) { this.lookup.makineleriYukle(terim); }
  personelAra(terim: string) { this.lookup.personelleriYukle(terim); }

  gecikmeGun = computed(() => {
    const hedef = this.p()?.hedefTarih;
    if (!hedef) return null;
    const fark = new Date(hedef).getTime() - Date.now();
    return Math.ceil(fark / 86400000);
  });

  private async paylasKutusuAc(setId: string, baslik: string, simge: string, renkArka: string) {
    const { PaylasKutusuComponent } = await import('@service/fikoyt-ui/src/lib/paylasim-sistemi/paylas-kutusu/paylas-kutusu.component');
    let bulunanSet: any;
    for (const g of SISTEM_PARAMETRE_SETLERI) {
      const s = g.altGruplar?.find((a: any) => a.id === setId);
      if (s) { bulunanSet = s; break; }
    }
    if (!bulunanSet) { this.nzMessage.warning(`Set bulunamadı: ${setId}`); return; }
    const setKopya = JSON.parse(JSON.stringify(bulunanSet));
    const kart: any = {
      _id: Date.now().toString(36), vt: 'FikoYT.sistem.hareketler', yol: 'FikoYT.sistem.hareketler.kalem',
      turu: 'KART', gizlilik: 'Herkese Açık', uygulama: [],
      veri: { solSimge: { baslik: simge, renkArka, renkYazi: '#fff' }, icerikler: [{
        _id: Date.now().toString(36), html: '', aciklama: '', sifre: null,
        ek: { turu: 'UYGULAMAICERIK', _secilenSetId: setKopya.id, parametreler: setKopya.parametreler || [], ...(setKopya.bilesen ? { bilesen: setKopya.bilesen } : {}) }
      }] },
    };
    const ref = this.modal.create({ nzTitle: `${simge} ${baslik}`, nzContent: PaylasKutusuComponent, nzWidth: 520, nzFooter: null, nzViewContainerRef: this.vcr });
    ref.afterOpen.subscribe(() => {
      const inst = ref.componentInstance;
      if (!inst) return;
      inst.kart = kart;
      inst.parametreSetleri = [JSON.parse(JSON.stringify(bulunanSet))];
      inst.parametreSetiZorunlu = true;
      inst.taslakDevreDisi = true;
      inst.paylasimYapildi?.subscribe(() => { ref.close(); this.nzNotification.success('Eklendi', `${baslik} kaydedildi`); this.lookup.makineleriYukle('', true); this.lookup.personelleriYukle('', true); });
      inst.CD?.detectChanges?.();
    });
  }

  yeniTezgahEkle() {
    this.paylasKutusuAc('hmi.makine-tanimi', 'Yeni Tezgah', '🏭', '#d46b08');
  }

  yeniPersonelEkle() {
    this.paylasKutusuAc('hmi.personel', 'Yeni Personel', '👤', '#722ed1');
  }
}
